import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import { StringArrayFormat41o1nrt6c6ex as StringArrayFormat } from '../../../../lightning-server-shared/com/lightningkite/lightningserver/StringArrayFormat.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_DefaultStringArrayFormat() {
  _init_properties_urlify_kt__msc8a5();
  var tmp0 = DefaultStringArrayFormat$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('DefaultStringArrayFormat', 0, tmp, _get_DefaultStringArrayFormat_$ref_z6qk3g(), null);
  return tmp0.f2();
}
var DefaultStringArrayFormat$delegate;
function DefaultStringArrayFormat$delegate$lambda() {
  _init_properties_urlify_kt__msc8a5();
  return new (StringArrayFormat())(get_DefaultJson().mz());
}
function _get_DefaultStringArrayFormat_$ref_z6qk3g() {
  return () => get_DefaultStringArrayFormat();
}
var properties_initialized_urlify_kt_7cyk41;
function _init_properties_urlify_kt__msc8a5() {
  if (!properties_initialized_urlify_kt_7cyk41) {
    properties_initialized_urlify_kt_7cyk41 = true;
    DefaultStringArrayFormat$delegate = lazy(DefaultStringArrayFormat$delegate$lambda);
  }
}
//region block: exports
export {
  get_DefaultStringArrayFormat as get_DefaultStringArrayFormatk3qh72vmys6l,
};
//endregion

//# sourceMappingURL=urlify.mjs.map
